import { OverlayTrigger, Popover } from "react-bootstrap"
import PopoverForm from "../PopoverForm/PopoverForm"
import { useEffect, useRef, useState } from "react";

  
const PopoverFormButton = ({id, url, className, children, name, element, closeOnSave=false, showPopover=false, field="name", isNew=null, finalizeTag=(id, tag, isNew)=>{}}) =>{
    const ref = useRef(null);
    name = name !== null ? name : element.form_title
    const [show, setShow] = useState(false);
    useEffect(() => {
        setShow(showPopover)
    }, [showPopover])
    const popover = <Popover 
                        id={`popover-${url}`}
                        className="field-popover"
                        style={{overflow: 'visible'}}
                        rootClose={true}
                    >
            <PopoverForm 
                url={url.replace('<pk>', id)} 
                setShow={setShow}
                saveHook={(data, index) => {closeOnSave && setShow(!data.every( (form) => form.success ));finalizeTag(data[index].pk, data[index].instance, true)}}
                className="popover-form" 
            />
    </Popover>
                        
    return  <OverlayTrigger
                placement="left"
                ref={ref}
                // container={document.getElementById('form-modal-content')}
                trigger="click"
                onToggle={() => {setShow(!show)}}
                show={show}
                containerPadding={20}
                // rootClose
                overlay={popover}
            >
            <a id="popover-form-button" className={`d-flex align-items-center action-button ${className}`}>
                {children}
                {name}
            </a>
    </OverlayTrigger>

}

export default PopoverFormButton;